<template>
  <div class="page-container">
    <div class="page-title">
      Payment Links
    </div>
    <PaymentLinkStep />
  </div>
</template>

<script>
export default {
  name: 'Payment_Link',
  components: {
    PaymentLinkStep: () => import('./components/PaymentLinkStep.vue')
  }
}
</script>

<style scoped>

</style>
